import React, { useState, useEffect, useRef  } from "react";
import { useParams,useNavigate } from 'react-router-dom';
import {  toast } from "react-toastify";
import CryptoJS from "crypto-js";
import "./Scheme.css";
import Input from "./Input";
import Select from "./Select";
import green_check from "./../../../images/svg/green-check.svg";
import danger_icon from "./../../../images/schemes/danger-icon.png";
import { getAllDistrictList, getAllSportList } from "../../../services/commonApiService/CommonApiService";
import { getUserDetails, getSubmittedFormData, resubmitSchemeApplication, getApplicationRemarksData } from "../../../services/schemeApiService/SchemeApiService";
import ViewDocument from "./ViewDocument";
import DatePickerField from "./DatePickerField";
import RemarkModal from "./RemarkModal";
import Modal from "./Modal";
import PreviouslyUpdatedDocuments from "./PreviouslyUpdatedDocuments";

const docUrl= process.env.REACT_APP_DOC_URL;
const alreadyUploadedDocUrl= process.env.REACT_APP_UPLOADED_DOC_URL;

const MAX_PHOTO_SIZE = 2 * 1024 * 1024; // 2MB
const MAX_DOC_SIZE = 2 * 1024 * 1024; // 2MB
const MAX_FIELDS = 10;

function changeDateFormat(originalDate){
  // Convert to a Date object
  const dateObj = new Date(originalDate);

  // Format as YYYY-MM-02
  const formatted = `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, '0')}-${String(dateObj.getDate()).padStart(2, '0')}`;

  return formatted;
}

const SubmittedSchemeForm = () => {

  const navigate = useNavigate();

  const { encryptedFormId } = useParams();

      
  let secretKey = process.env.REACT_APP_SECRET_KEY ;
  let bytes = CryptoJS.AES.decrypt(decodeURIComponent(encryptedFormId), secretKey);
  let applicantId = bytes.toString(CryptoJS.enc.Utf8);

  const [formData, setFormData] = useState({"gender":"","district":"","sport":"","medal":"","competition":"","event":"","sport_category_senior_junior":"","sport_category_team_ind":"","contact":"","aadhar":"","pincode":"","player_bank_account_number":"","number_of_players":null,"coach_pincode":"","coach_contact":"","coach_bank_account_number":"","rec_dep_mobile":""});
  const [errors, setErrors] = useState({});
  const [isDeclared, setIsDeclared] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [applicationId, setApplicationId] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [readOnlyFields, setReadOnlyFields] = useState([]);
  const [fetchedAadhaar, setFetchedAadhaar] = useState(null);
  const [fetchedProfile, setFetchedProfile] = useState(null);
  const [remarkOpen, setRemarkOpen] = useState(false);
  const [lastRemark, setLastRemark] = useState({"id":0,"message":""});
  const [allRemarks, setAllRemarks]=useState(null);
  const [applicationStatus, setApplicationStatus] = useState("");
  const [fields, setFields] = useState([
    { description: '', document: null, error: '' },
  ]);
  const [formError, setFormError] = useState('');
  const fileInputRefs = useRef([]);

  // const [profilePhoto, setProfilePhoto] = useState(null);

  const [competetionTypes, setCompetetionTypes]=useState([
    { id: 1, label: 'Olympic Games' },
    { id: 2, label: 'World cup/Championship' },
    { id: 3, label: 'Asian games' },
    { id: 4, label: 'Commonwealth games' },
    { id: 5, label: 'Asian Championship' },
    { id: 6, label: 'Commonwealth Championship' },
    { id: 7, label: 'South Asian Games' },
    { id: 8, label: 'National Games' },
    { id: 9, label: 'World university games/World School Games, World Police Games' },
    { id: 10, label: 'International Veteran Master Championship' },
    { id: 11, label: 'National championship, National School Games, Khelo India Games, All India Rural Games, National Women Games' },
    { id: 12, label: 'All India University Championship/Tournament, Khelo India University Games' },
    { id: 13, label: 'National Civil Services Competition, All India Police Tournament' },
    { id: 14, label: 'National Veteran Master championship' },
  ]);
  
  const [medalList, setMedalList]=useState([
    { id: 1, label: 'Gold' },
    { id: 2, label: 'Silver' },
    { id: 3, label: 'Bronze' },
    { id: 4, label: 'Participation' },
  ]);
  const [genderList, setGenderList]=useState([
    { id: "M", label: 'Male' },
    { id: "F", label: 'Female' },
    { id: "O", label: 'Other' }
  ]);

  const [districtList, setDistrictList]=useState([
  ]);

  const [sportList, setSportList]=useState([
  ]);

  const [sportCategoryList, setSportCategoryList]=useState([
    { id: 1, label: 'Senior' },
    { id: 2, label: 'Junior/youth' },
    { id: 3, label: 'Sub-junior' },
    { id: 4, label: 'Other' }
  ]);

  const [sportCategoryTeamIndList, setSportCategoryTeamIndList]=useState([
    { id: 1, label: 'Individual' },
    { id: 2, label: 'Team' }
  ]);

    const fetchDistricts = async () => {
      try {
        const response = await getAllDistrictList(4016);

        let transformedData = response.data.map(item => ({
          id: item.id,
          label: item.name
        }));

        setDistrictList(transformedData);

      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    const fetchSports = async () => {
      try {
        const response = await getAllSportList();
        // console.log(response.data);

        let transformedData = response.data.data.map(item => ({
          id: item.sport_id,
          label: item.sport_name
        }));

        setSportList(transformedData);

      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    // const formatDate = (dateStr) => {
    //   const [year, month, day] = dateStr.split('-');
    //   return `${day}-${month}-${year}`;
    // };


    const fetchFormDetails = async () => {
      try {
        const response = await getSubmittedFormData(applicantId);
        // console.log(response.data.data[0]);
        let registrationDetails=response.data.data[0];

        const documents = registrationDetails.documents || [];

        // console.log("documents",documents);

        const getDocumentPath = (type) => {
          const doc = documents.find(d => d.type === type);
          return doc ? doc.path : "";
        };

        // console.log("training_certificate",getDocumentPath("training_certificate"));
        // console.log("stamp_paper_training",getDocumentPath("stamp_paper_training"));
        

        setFormData({
          ...formData,
          "name":registrationDetails.name,
          "father_name":registrationDetails.father_name,
          "dob":registrationDetails.dob,
          "gender":registrationDetails.gender,
          "email":registrationDetails.email,
          "aadhar":registrationDetails.aadhar,
          "contact":registrationDetails.contact,
          "address":registrationDetails.address,
          "district":registrationDetails.district,
          "pincode":registrationDetails.pincode,
          "sport":registrationDetails.sport,
          "competition":registrationDetails.competition,
          "medal":registrationDetails.medal,
          "sport_category_senior_junior":registrationDetails.sport_category_senior_junior,
          "sport_category_team_ind":registrationDetails.sport_category_team_ind,
          "association_name":registrationDetails.association_name,
          "competition_start_date":changeDateFormat(registrationDetails.competition_start_date),
          "competition_end_date":changeDateFormat(registrationDetails.competition_end_date),
          "number_of_players":registrationDetails.number_of_players,
          "player_bank_account_number":registrationDetails.player_bank_account_number,
          "player_ifsc_code":registrationDetails.player_ifsc_code,
          "player_bank_name":registrationDetails.player_bank_name,
          "player_bank_branch":registrationDetails.player_bank_branch,
          "coach_name":registrationDetails.coach_name,
          "coach_address":registrationDetails.coach_address,
          "coach_pincode":registrationDetails.coach_pincode,
          "coach_contact":registrationDetails.coach_contact,
          "coach_bank_account_number":registrationDetails.coach_bank_account_number,
          "coach_ifsc_code":registrationDetails.coach_ifsc_code,
          "coach_bank_name":registrationDetails.coach_bank_name,
          "coach_bank_branch":registrationDetails.coach_bank_branch,
          "second_coach_name":registrationDetails.second_coach_name,
          "second_coach_address":registrationDetails.second_coach_address,
          "second_coach_pincode":registrationDetails.second_coach_pincode,
          "second_coach_contact":registrationDetails.second_coach_contact,
          "second_coach_bank_account_number":registrationDetails.second_coach_bank_account_number,
          "second_coach_ifsc_code":registrationDetails.second_coach_ifsc_code,
          "second_coach_bank_name":registrationDetails.second_coach_bank_name,
          "second_coach_bank_branch":registrationDetails.second_coach_bank_branch,
          "third_coach_name":registrationDetails.third_coach_name,
          "third_coach_address":registrationDetails.third_coach_address,
          "third_coach_pincode":registrationDetails.third_coach_pincode,
          "third_coach_contact":registrationDetails.third_coach_contact,
          "third_coach_bank_account_number":registrationDetails.third_coach_bank_account_number,
          "third_coach_ifsc_code":registrationDetails.third_coach_ifsc_code,
          "third_coach_bank_name":registrationDetails.third_coach_bank_name,
          "third_coach_bank_branch":registrationDetails.third_coach_bank_branch,
          "rec_dep_name":registrationDetails.rec_dep_name,
          "rec_dep_officer_name":registrationDetails.rec_dep_officer_name,
          "rec_dep_address":registrationDetails.rec_dep_address,
          "rec_dep_mobile":registrationDetails.rec_dep_mobile,
          "event":registrationDetails.event,
          // Document fields
          "training_certificate": getDocumentPath("training_certificate"),
          "second_training_certificate": getDocumentPath("second_training_certificate"),
          "third_training_certificate": getDocumentPath("third_training_certificate"),
          "applicant_photo": getDocumentPath("applicant_photo"),
          "stamp_paper_training": getDocumentPath("stamp_paper_training"),
          "second_stamp_paper_training": getDocumentPath("second_stamp_paper_training"),
          "third_stamp_paper_training": getDocumentPath("third_stamp_paper_training"),
          "tournament_certificate": getDocumentPath("tournament_certificate"),
          "sports_proof": getDocumentPath("sports_proof"),
          "association_verification_form": getDocumentPath("association_verification_form"),
          "applicant_aadhaar": getDocumentPath("applicant_aadhaar"),
          "other_doc": getDocumentPath("other_doc"),
          });

          setApplicationStatus(registrationDetails.status);

          if(registrationDetails.community_approval_status==="clarification"){
            setRemarkOpen(true);
            // setLastRemark({...lastRemark,"message":registrationDetails.community_comment});
          }

      } catch (error) {
        console.error("Error fetching userdetails:", error);
      }
    };

    const fetchUserDetails = async () => {
      try {
        const response = await getUserDetails();
        let userdetails=response.data.data;

        const documents = userdetails.documents || [];

          const getDocumentPath = (type) => {
            const doc = documents.find(d => d.doc_name === type);
            return doc ? doc.doc_file : "";
          };

          if(getDocumentPath("profile_image")){
            setFetchedProfile(getDocumentPath("profile_image"));
          }
          if(getDocumentPath("aadhaar")){
            setFetchedAadhaar(getDocumentPath("aadhaar"));
          }

      } catch (error) {
        console.error("Error fetching userdetails:", error);
      }
    };   
    
    const fetchRemarksData = async () => {
      try {
        const response = await getApplicationRemarksData(applicantId);
        let remarksData=response.data.data;
        console.log("remarksData",remarksData);
        setAllRemarks(remarksData);

        if (remarksData.rows && remarksData.rows.length > 0) {
          const last_remark = remarksData.rows[remarksData.rows.length - 1];
          console.log(last_remark);
          setLastRemark({...lastRemark,"id":last_remark.id,"message":last_remark.remark});
        }

      } catch (error) {
        console.error("Error fetching remarks data:", error);
      }
    };
  
    // Fetch cities, and sports on initial render
    useEffect(() => {
      fetchDistricts();
      fetchSports();
      fetchFormDetails();
      fetchUserDetails();
      fetchRemarksData();
    }, []);

  function fieldName(field) {
    switch (field) {
      case "name":
        return "Player's Name";
      case "father_name":
        return "Father's Name";
      case "dob":
        return "Date of Birth";
      case "gender":
        return "Gender";
      case "email":
        return "Email ID";
      case "contact":
        return "Contact Number";
      case "aadhar":
        return "Aadhar Number";
      case "address":
        return "Full Address";
      case "district":
        return "District";
      case "pincode":
        return "Pincode";
      case "sport_category_senior_junior":
        return "Sport Category";
      case "sport_category_team_ind":
        return "Sport Category";
      case "association_name":
        return "Association Name";
      case "competition_start_date":
        return "Competition Start Date";
      case "competition_end_date":
        return "Competition End Date";
      case "number_of_players":
        return "Number of Players";
      case "player_bank_account_number":
        return "Bank Account Number";
      case "player_ifsc_code":
        return "IFSC Code";
      case "player_bank_name":
        return "Bank Name";
      case "player_bank_branch":
        return "Bank Branch";
      case "coach_bank_account_number":
        return "Bank Account Number";
      case "coach_ifsc_code":
        return "IFSC Code";
      case "coach_bank_name":
        return "Bank Name";
      case "coach_bank_branch":
        return "Bank Branch";
      case "coach_name":
        return "Coach Name";
      case "coach_address":
        return "Address";
      case "coach_pincode":
        return "Pincode";
      case "coach_contact":
        return "Contact Number";
      case "rec_dep_name":
        return "Recommending Department Name";
      case "rec_dep_officer_name":
        return "Recommending Officer Name";
      case "rec_dep_address":
        return "Recommending Department Address";
      case "rec_dep_mobile":
        return "Recommending Officer Mobile";
      case "applicant_photo":
        return "Applicant's Photo";
      case "competition":
        return "Competition Name";
      case "sport":
        return "Sport";
      case "medal":
        return "Medal";
      case "training_certificate":
        return "Training Certificate";
      case "tournament_certificate":
        return "Tournament Certificate";
      case "stamp_paper_training":
        return "Stamp Paper Declaration";
      case "association_verification_form":
        return "Association Verification Form";
      case "sports_proof":
        return "Sports Proof";
      case "applicant_aadhaar":
        return "Aadhar Card";
      default:
        return field;
    }
  }
  
  const validateFile = (file, type) => {
    if (!file) return false;
    const fileType = file.type;
    const fileSize = file.size;

    if (type === "photo") {
      return (["image/jpeg", "image/png"].includes(fileType) && fileSize <= MAX_PHOTO_SIZE);
    }

    return fileType === "application/pdf" && fileSize <= MAX_DOC_SIZE;
  };

  const handleSelectChange = (e, name) => {
    setFormData({ ...formData, [name]: e.target.value });
    setErrors(prev => ({ ...prev, [name]: null }));
  };

  const handleChange = (index, field, value) => {
    const updatedFields = [...fields];
    updatedFields[index][field] = value;
    setFields(updatedFields);
  };

  const handleFileChange = (index, file) => {
    const updatedFields = [...fields];

    if (file) {
      if (file.type !== 'application/pdf') {
        updatedFields[index].error = 'Only PDF files are allowed.';
        updatedFields[index].document = null;
        fileInputRefs.current[index].value = ''; // reset file input
      } else if (file.size > MAX_DOC_SIZE) {
        updatedFields[index].error = 'File size should not exceed 2 MB.';
        updatedFields[index].document = null;
        fileInputRefs.current[index].value = '';
      } else {
        updatedFields[index].error = '';
        updatedFields[index].document = file;
      }
    } else {
      updatedFields[index].error = '';
      updatedFields[index].document = null;
    }

    setFields(updatedFields);
  };

  const addMoreFields = () => {
    if (fields.length < MAX_FIELDS) {
      setFields([...fields, { description: '', document: null, error: '' }]);
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setFormError('');

  //   const nonEmptyFields = fields.filter(
  //     ({ description, document }) => description.trim() !== '' || document !== null
  //   );

  //   if (fields.length === 1) {
  //     if (fields[0].description.trim() === '' && !fields[0].document) {
  //       setFormError('Please fill at least one field: description or document.');
  //       return;
  //     }
  //   } else {
  //     const last = fields[fields.length - 1];
  //     if (last.description.trim() === '' && !last.document) {
  //       // Remove the last empty field
  //       setFields((prev) => prev.slice(0, -1));
  //       return; // Exit so the form re-renders first, and then user can click again
  //     }

  //     // Check any other field for being completely empty
  //     for (let i = 0; i < fields.length; i++) {
  //       const { description, document } = fields[i];
  //       if (description.trim() === '' && !document) {
  //         setFormError(`Please fill at least one field (description/document) in section ${i + 1}.`);
  //         return;
  //       }

  //       if (fields[i].error) {
  //         setFormError(`Please fix the errors before submitting.`);
  //         return;
  //       }
  //     }
  //   }

  //   if (!isDeclared) {
  //     setFormError('You must accept the declaration.');
  //     return;
  //   }

  //   // Prepare FormData
  //   const formData = new FormData();
  //   fields.forEach((item, index) => {
  //     formData.append(`description_${index}`, item.description);
  //     if (item.document) {
  //       formData.append(`document_${index}`, item.document);
  //     }
  //   });

  //   try {
  //     const response = await fetch('/api/upload-documents', {
  //       method: 'POST',
  //       body: formData,
  //     });

  //     const result = await response.json();
  //     alert('Form submitted successfully!');
  //     console.log(result);
  //   } catch (err) {
  //     console.error(err);
  //     setFormError('Error submitting form.');
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError('');

    let updatedFields = [...fields];

    // Remove last empty field if it's totally blank
    if (
      updatedFields.length > 1 &&
      updatedFields[updatedFields.length - 1].description.trim() === '' &&
      !updatedFields[updatedFields.length - 1].document
    ) {
      updatedFields = updatedFields.slice(0, -1);
    }

    if (updatedFields.length === 1 && 
        updatedFields[0].description.trim() === '' && 
        !updatedFields[0].document
    ) {
      setFormError('Please fill at least one field: description or document.');
      return;
    }

    for (let i = 0; i < updatedFields.length; i++) {
      const { description, document, error } = updatedFields[i];
      if (description.trim() === '' && !document) {
        setFormError(`Please fill description or upload document in section ${i + 1}.`);
        return;
      }
      if (error) {
        setFormError(`Please resolve the errors in section ${i + 1}.`);
        return;
      }
    }

    if (!isDeclared) {
      setFormError('Please accept the declaration before submitting.');
      return;
    }

    const formData = new FormData();

    console.log(lastRemark);
    formData.append("application_id",applicantId);
    formData.append("remark_id",lastRemark.id);

    updatedFields.forEach((item, index) => {
      formData.append(`items[${index}][description]`, item.description);
      if (item.document) {
        formData.append(`items[${index}][document]`, item.document);
      }else{
        formData.append(`items[${index}][document]`, null);
      }
    });

    try {
      // const response = await fetch('/api/resubmit-application', {
      //   method: 'POST',
      //   body: formData,
      // });
      setSubmitLoading(true);
      const response = await resubmitSchemeApplication(formData);

      if(response.data.success){
        setSubmitLoading(false);
        // setFormData({"gender":"","district":"","sport":"","medal":"","competition":"","sport_category_senior_junior":"","sport_category_team_ind":""});
        setTimeout(() => {
          setModalOpen(true);
        }, 500);
      }else{
        setSubmitLoading(false);
        toast.error("Error occured while submitting form !", {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }

      // const result = await response.json();
      // alert('Form submitted successfully!');
      // console.log(result);
      
    } catch (err) {
      console.error(err);
      setFormError('Error submitting form.');
    }
  };

  const canAddMore = () => {
    const last = fields[fields.length - 1];
    return last.description.trim() !== '' || last.document !== null;
  };

  const scrollToSection = (sectionid) => {
  const element = document.getElementById(sectionid);
  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
  }
};

  return (
    <div className="relative scheme-form-container application-form-readmode user-schemes-container">
      <div className="form-container">

        <div className="form-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        
        <div>
        <h1 className="form-title applicantion-id">Application ID: <span></span>{applicantId}</h1>
          <h1 className="form-title">Application for Cash Award Scheme</h1>
          {/* <Badge bg="" className='badge-primary light badge-lg rounded-pill'>Sports Department</Badge> */}
          <span className="badge mb-2 text-white"
              style={{
                  background: "linear-gradient(90deg, #7942D1 0%, #2A1647 100%)",
                  fontSize: "0.80rem",
                  padding: "0.5em 1.5em",
                  borderRadius: "16056.36px"
              }}>Sports Department</span>

        </div>
        {applicationStatus==="clarification" && <button class="view-remark-btn" onClick={()=>setRemarkOpen(true)}>View Remark</button>}
        {/* <section className="profile-preview-section">
            {profilePhoto ? (
              <div className="profile-photo-container">
                <img src={profilePhoto} alt="Profile Preview" className="profile-photo" />
              </div>
            )
            :(
              <input
              type="file"
              accept="image/*"
              onChange={handleProfilePhotoChange}
              style={{ marginBottom: "1rem" }}
            />
            )
            }
        </section> */}

        </div>

        <form className="form">

          <section className="">
            <h4 className="application-section-heading">General Information</h4>
            <div className="form-inline-group">
              <Input label="Player's Name*" placeholder="Enter Player's Name" name="name" value={formData.name} onChange={(e) => handleChange(e, "name")} error={errors.name} isReadOnly={true} />
              <Input label="Father's Name*" placeholder="Enter Father's Name" name="father_name" value={formData.father_name} onChange={(e) => handleChange(e, "father_name")} error={errors.father_name} isReadOnly={true}/>
            </div>
            <div className="form-inline-group">
              <DatePickerField label="Date of Birth (D.O.B)*" placeholder="Enter Date of Birth" value={formData.dob} name="dob" type="date" onChange={(e) => handleChange(e, "dob")}  error={errors.dob} isReadOnly={true}/>
              <Select label="Gender*" placeholder="Select Gender" options={genderList} value={formData.gender}  onChange={(e) => handleSelectChange(e, "gender")} error={errors.gender} isReadOnly={true}/>
            </div>
            <div className="form-inline-group">
              <Input label="Email ID*" placeholder="Enter Email ID" name="email" value={formData.email} onChange={(e) => handleChange(e, "email")} error={errors.email} isReadOnly={true}/>
              <Input label="Contact Number*" placeholder="Enter Contact Number" name="contact"  value={formData.contact} maxLength={10} inputMode="numeric" onChange={(e) => handleChange(e, "contact")} error={errors.contact} isReadOnly={true}/>
            </div>
            <div className="form-inline-group">
              <Input label="Aadhar Number*" placeholder="Enter Aadhar Number" name="aadhar" maxLength={12} inputMode="numeric" value={formData.aadhar} onChange={(e) => handleChange(e, "aadhar")} error={errors.aadhar} isReadOnly={readOnlyFields.includes('aadhar')} />
              <Input label="Full Address*" placeholder="Enter Full Address" name="address" value={formData.address} onChange={(e) => handleChange(e, "address")} error={errors.address} isReadOnly={true}/>
            </div>
            <div className="form-inline-group">
              <Select label="District*" placeholder="Select District" options={districtList} value={formData.district}  onChange={(e) => handleSelectChange(e, "district")} error={errors.district} isReadOnly={true}/>
              <Input label="Pincode*" placeholder="Enter Pincode" name="pincode" inputMode="numeric" value={formData.pincode} maxLength={6} onChange={(e) => handleChange(e, "pincode")} error={errors.pincode} isReadOnly={true}/>
            </div>

          </section>

          <section className="">
            <h4 className="application-section-heading">Sport and Competition Details</h4>
            <div className="form-inline-group">
              <Select label="Name of the Sport*" placeholder="Select Name of the Sport" options={sportList} value={formData.sport}  onChange={(e) => handleSelectChange(e, "sport")} error={errors.sport}/>
              <Select label="Name of the Competition*" placeholder="Select Name of the Competition" options={competetionTypes} value={formData.competition} onChange={(e) => handleSelectChange(e, "competition")} error={errors.competition}/>
            </div>
            <div className="form-inline-group">
              <Input label="Name of the Event*" placeholder="Enter Event Name" name="event" value={formData.event} onChange={(e) => handleChange(e, "event")} />
              <Select label="Medal(s) Received*" placeholder="Select Medal" options={medalList} value={formData.medal}  onChange={(e) => handleSelectChange(e, "medal")} error={errors.medal}/>
            </div>
            <div className="form-inline-group">
              <Select label="Category*" placeholder="Select Sport Category" options={sportCategoryList} value={formData.sport_category_senior_junior}  onChange={(e) => handleSelectChange(e, "sport_category_senior_junior")} error={errors.sport_category_senior_junior}/>
              <Input label="Association through which participated in the competition*" placeholder="Enter Name of the Association" name="association_name" value={formData.association_name} onChange={(e) => handleChange(e, "association_name")} error={errors.association_name}/>
            </div>
            <div className="form-inline-group">
              <DatePickerField label="Competition Start Date*" placeholder="Select Competition Start Date" name="competition_start_date" type="date" value={formData.competition_start_date} onChange={(e) => handleChange(e, "competition_start_date")}  error={errors.competition_start_date}/>
              <DatePickerField label="Competition End Date*" placeholder="Select Competition End Date" name="competition_end_date" type="date" value={formData.competition_end_date} onChange={(e) => handleChange(e, "competition_end_date")}  error={errors.competition_end_date}/>
            </div>
            <div className="form-inline-group">
              <Select label="Team/Individual*" placeholder="Select Sport Category" options={sportCategoryTeamIndList} value={formData.sport_category_team_ind}  onChange={(e) => handleSelectChange(e, "sport_category_team_ind")} error={errors.sport_category_team_ind}/>
              {formData.sport_category_team_ind==="2" ? (
              <Input label="Total Number of Player in Team*" placeholder="Enter Number of player" name="number_of_players" value={formData.number_of_players} inputMode="numeric" onChange={(e) => handleChange(e, "number_of_players")} error={errors.number_of_players}/>
              ):(
                <div className="mb-3"></div>
              )}
            </div>

          </section>

          <section className="">
            <h4 className="application-section-heading">Applicant’s Bank Details</h4>
            <div className="form-inline-group">
              <Input label="Bank Account Number*" placeholder="Enter Bank Account Number" inputMode="numeric" value={formData.player_bank_account_number} maxLength={18} name="player_bank_account_number" onChange={(e) => handleChange(e, "player_bank_account_number")} error={errors.player_bank_account_number}/>
              <Input label="IFSC Code*" placeholder="Enter IFSC Code" name="player_ifsc_code" maxLength={11} value={formData.player_ifsc_code} onChange={(e) => handleChange(e, "player_ifsc_code")} error={errors.player_ifsc_code}/>
            </div>
            <div className="form-inline-group">
              <Input label="Bank Name*" placeholder="Enter Bank Name" name="player_bank_name" value={formData.player_bank_name} onChange={(e) => handleChange(e, "player_bank_name")} error={errors.player_bank_name}/>
              <Input label="Bank Branch Name*" placeholder="Enter Bank Branch" name="player_bank_branch" value={formData.player_bank_branch} onChange={(e) => handleChange(e, "player_bank_branch")} error={errors.player_bank_branch}/>
            </div>

          </section>

          <section className="">
            <h4 className="application-section-heading">Details of Recommendation of Department/ Institution or Recognized State Sports Association</h4>
            <div className="form-inline-group">
              <Input label="Name of Department / Institution / State Sports Association*" placeholder="Enter Department / Institution / State Sports Association" name="rec_dep_name" value={formData.rec_dep_name} onChange={(e) => handleChange(e, "rec_dep_name")} error={errors.rec_dep_name}/>
              <Input label="Name of Officer*" placeholder="Enter Name of Officer" name="rec_dep_officer_name" value={formData.rec_dep_officer_name} onChange={(e) => handleChange(e, "rec_dep_officer_name")} error={errors.rec_dep_officer_name}/>
            </div>
            <div className="form-inline-group">
              <Input label="Full Address*" placeholder="Enter Full Address" name="rec_dep_address" value={formData.rec_dep_address} onChange={(e) => handleChange(e, "rec_dep_address")} error={errors.rec_dep_address}/>
              <Input label="Mobile Number*" placeholder="Enter Mobile Number" inputMode="numeric" value={formData.rec_dep_mobile} maxLength={10} name="rec_dep_mobile" onChange={(e) => handleChange(e, "rec_dep_mobile")} error={errors.rec_dep_mobile}/>
            </div>

          </section>

          {formData.coach_name && <div className="card">
              <div className="card-header">
                <h4 className="application-section-heading">Coach & their Bank Details</h4>
                <small className="coach-details-remove" ></small>
              </div>
              <div className="card-body">
                <section className="">
                  <div className="form-inline-group">
                    <Input label="Name of Coach*" placeholder="Enter Name of Coach" name="coach_name" value={formData.coach_name} onChange={(e) => handleChange(e, "coach_name")} error={errors.coach_name}/>
                    <Input label="Full Address*" placeholder="Enter Full Address" name="coach_address" value={formData.coach_address} onChange={(e) => handleChange(e, "coach_address")} error={errors.coach_address}/>
                  </div>
                  <div className="form-inline-group">
                    <Input label="Pincode*" placeholder="Enter Pincode" name="coach_pincode" maxLength={6} inputMode="numeric" value={formData.coach_pincode} onChange={(e) => handleChange(e, "coach_pincode")} error={errors.coach_pincode}/>
                    <Input label="Contact Number*" placeholder="Enter Contact Number" inputMode="numeric" value={formData.coach_contact} maxLength={10} name="coach_contact" onChange={(e) => handleChange(e, "coach_contact")} error={errors.coach_contact}/>
                  </div>

                  <hr class="custom-line" />

                  <div className="form-inline-group">
                    <Input label="Bank Account Number*" placeholder="Enter Bank Account Number" maxLength={18} inputMode="numeric" value={formData.coach_bank_account_number} name="coach_bank_account_number" onChange={(e) => handleChange(e, "coach_bank_account_number")} error={errors.coach_bank_account_number}/>
                    <Input label="IFSC Code*" placeholder="Enter IFSC Code" maxLength={11} name="coach_ifsc_code" value={formData.coach_ifsc_code} onChange={(e) => handleChange(e, "coach_ifsc_code")} error={errors.coach_ifsc_code}/>
                  </div>
                  <div className="form-inline-group">
                    <Input label="Bank Name*" placeholder="Enter Bank Name" name="coach_bank_name" value={formData.coach_bank_name} onChange={(e) => handleChange(e, "coach_bank_name")} error={errors.coach_bank_name}/>
                    <Input label="Bank Branch Name*" placeholder="Enter Bank Branch" name="coach_bank_branch" value={formData.coach_bank_branch} onChange={(e) => handleChange(e, "coach_bank_branch")} error={errors.coach_bank_branch}/>
                  </div>

                  <hr class="custom-line" />

                  <div className="form-inline-group">
                    <ViewDocument label="Enclose 1 year sport diploma for the coach or equivalent or 6 week certificate or certificate of training of the national federation of the concerned sport(for Coach) *" filepath={docUrl+formData.training_certificate} placeholder="View Certificate" />
                    <ViewDocument label="Details related to the training of the instructor on a stamp paper of Rs.10(by player) *" filepath={docUrl+formData.stamp_paper_training} placeholder="View Certificate"/>
                  </div>

                </section>
              </div>
          </div>}

          {formData.second_coach_name && <div className="card">
              <div className="card-header">
                <h4 className="application-section-heading">Coach & their Bank Details</h4>
                <small className="coach-details-remove" ></small>
              </div>
              <div className="card-body">
                <section className="">
                  <div className="form-inline-group">
                    <Input label="Name of Coach*" placeholder="Enter Name of Coach" name="second_coach_name" value={formData.second_coach_name} onChange={(e) => handleChange(e, "second_coach_name")} error={errors.second_coach_name}/>
                    <Input label="Full Address*" placeholder="Enter Full Address" name="second_coach_address" value={formData.second_coach_address} onChange={(e) => handleChange(e, "second_coach_address")} error={errors.second_coach_address}/>
                  </div>
                  <div className="form-inline-group">
                    <Input label="Pincode*" placeholder="Enter Pincode" name="second_coach_pincode" maxLength={6} inputMode="numeric" value={formData.second_coach_pincode} onChange={(e) => handleChange(e, "second_coach_pincode")} error={errors.second_coach_pincode}/>
                    <Input label="Contact Number*" placeholder="Enter Contact Number" inputMode="numeric" value={formData.second_coach_contact} maxLength={10} name="second_coach_contact" onChange={(e) => handleChange(e, "second_coach_contact")} error={errors.second_coach_contact}/>
                  </div>

                  <hr class="custom-line" />

                  <div className="form-inline-group">
                    <Input label="Bank Account Number*" placeholder="Enter Bank Account Number" maxLength={18} inputMode="numeric" value={formData.second_coach_bank_account_number} name="second_coach_bank_account_number" onChange={(e) => handleChange(e, "second_coach_bank_account_number")} error={errors.second_coach_bank_account_number}/>
                    <Input label="IFSC Code*" placeholder="Enter IFSC Code" maxLength={11} name="second_coach_ifsc_code" value={formData.second_coach_ifsc_code} onChange={(e) => handleChange(e, "second_coach_ifsc_code")} error={errors.second_coach_ifsc_code}/>
                  </div>
                  <div className="form-inline-group">
                    <Input label="Bank Name*" placeholder="Enter Bank Name" name="second_coach_bank_name" value={formData.second_coach_bank_name} onChange={(e) => handleChange(e, "second_coach_bank_name")} error={errors.second_coach_bank_name}/>
                    <Input label="Bank Branch Name*" placeholder="Enter Bank Branch" name="second_coach_bank_branch" value={formData.second_coach_bank_branch} onChange={(e) => handleChange(e, "second_coach_bank_branch")} error={errors.second_coach_bank_branch}/>
                  </div>
                  
                  <hr class="custom-line" />

                  <div className="form-inline-group">
                    <ViewDocument label="Enclose 1 year sport diploma for the coach or equivalent or 6 week certificate or certificate of training of the national federation of the concerned sport(for Coach) *" filepath={docUrl+formData.second_training_certificate} placeholder="View Certificate" />
                    <ViewDocument label="Details related to the training of the instructor on a stamp paper of Rs.10(by player) *" filepath={docUrl+formData.second_stamp_paper_training} placeholder="View Certificate"/>
                  </div>


                </section>
              </div>
          </div>}

          {formData.third_coach_name && <div className="card">
              <div className="card-header">
                <h4 className="application-section-heading">Coach & their Bank Details</h4>
                <small className="coach-details-remove" ></small>
              </div>
              <div className="card-body">
                <section className="">
                  <div className="form-inline-group">
                    <Input label="Name of Coach*" placeholder="Enter Name of Coach" name="third_coach_name" value={formData.third_coach_name} onChange={(e) => handleChange(e, "third_coach_name")} error={errors.third_coach_name}/>
                    <Input label="Full Address*" placeholder="Enter Full Address" name="third_coach_address" value={formData.third_coach_address} onChange={(e) => handleChange(e, "third_coach_address")} error={errors.third_coach_address}/>
                  </div>
                  <div className="form-inline-group">
                    <Input label="Pincode*" placeholder="Enter Pincode" name="third_coach_pincode" maxLength={6} inputMode="numeric" value={formData.third_coach_pincode} onChange={(e) => handleChange(e, "third_coach_pincode")} error={errors.third_coach_pincode}/>
                    <Input label="Contact Number*" placeholder="Enter Contact Number" inputMode="numeric" value={formData.third_coach_contact} maxLength={10} name="third_coach_contact" onChange={(e) => handleChange(e, "third_coach_contact")} error={errors.third_coach_contact}/>
                  </div>

                  <hr class="custom-line" />

                  <div className="form-inline-group">
                    <Input label="Bank Account Number*" placeholder="Enter Bank Account Number" maxLength={18} inputMode="numeric" value={formData.third_coach_bank_account_number} name="third_coach_bank_account_number" onChange={(e) => handleChange(e, "third_coach_bank_account_number")} error={errors.third_coach_bank_account_number}/>
                    <Input label="IFSC Code*" placeholder="Enter IFSC Code" maxLength={11} name="third_coach_ifsc_code" value={formData.third_coach_ifsc_code} onChange={(e) => handleChange(e, "third_coach_ifsc_code")} error={errors.third_coach_ifsc_code}/>
                  </div>
                  <div className="form-inline-group">
                    <Input label="Bank Name*" placeholder="Enter Bank Name" name="third_coach_bank_name" value={formData.third_coach_bank_name} onChange={(e) => handleChange(e, "third_coach_bank_name")} error={errors.third_coach_bank_name}/>
                    <Input label="Bank Branch Name*" placeholder="Enter Bank Branch" name="third_coach_bank_branch" value={formData.third_coach_bank_branch} onChange={(e) => handleChange(e, "third_coach_bank_branch")} error={errors.third_coach_bank_branch}/>
                  </div>
                  
                  <hr class="custom-line" />

                  <div className="form-inline-group">
                    <ViewDocument label="Enclose 1 year sport diploma for the coach or equivalent or 6 week certificate or certificate of training of the national federation of the concerned sport(for Coach) *" filepath={docUrl+formData.third_training_certificate} placeholder="View Certificate" />
                    <ViewDocument label="Details related to the training of the instructor on a stamp paper of Rs.10(by player) *" filepath={docUrl+formData.third_stamp_paper_training} placeholder="View Certificate"/>
                  </div>

                </section>
              </div>
          </div>}

          <div className="card">
              <div className="card-header">
                <h4 className="card-title">Documents</h4>
                <small className="card-subtitle"></small>
              </div>
              <div className="card-body">

                  <div className="">
                      <div className="form-inline-group">
                        <ViewDocument label="Sports Proof/evidence of participation from Uttrakhand *" filepath={docUrl+formData.sports_proof} placeholder="View Certificate"/>
                        {fetchedProfile?<ViewDocument label="Upload Applicant's Photo *" filepath={alreadyUploadedDocUrl+fetchedProfile} placeholder="View Photo"/>
                        :<div className="mb-3"></div>}
                      </div>
                      <div className="form-inline-group">
                        <ViewDocument label="Related Tournament Certificate *" filepath={docUrl+formData.tournament_certificate} placeholder="View Certificate"/>
                        <ViewDocument label="Association Verification Form *" filepath={docUrl+formData.association_verification_form} placeholder="View Form"/>
                      </div>
                      <div className="form-inline-group">
                        {formData.applicant_aadhaar?<ViewDocument label="Aadhaar Card *" filepath={docUrl+formData.applicant_aadhaar} placeholder="View Certificate"/>
                        :<ViewDocument label="Aadhaar Card *" filepath={alreadyUploadedDocUrl+fetchedAadhaar} placeholder="View Aadhaar"/>}
                        {formData.other_doc?<ViewDocument label="Any Other Documents (Optional)" filepath={docUrl+formData.other_doc} placeholder="View Document"/>
                        :<div className="mb-3"></div>}
                      </div>
                  </div>
              </div>
          </div>
        </form>
        
        <div class="section">
          {allRemarks?.rows.map((rem,index)=>(
            rem.remark_resolved && <>
            {index==0 && <h3>Last Documents Update here</h3>}
            <PreviouslyUpdatedDocuments serial={index+1} data={rem}/>
            </>
          ))}
          
        </div>

      {applicationStatus==="clarification" && (
      <form onSubmit={handleSubmit} id="resubmission-form">
      
        <div class="section">
          <h3>Committee Remark</h3>
          <div class="remark-box">
            {lastRemark.message}
          </div>
        </div>

        <div class="section reupload-doc-section">
          <h3>Re-upload Documents here</h3>
          {fields.map((field, index) => (
            <div key={index} style={{ marginBottom: '0px', paddingBottom: '15px' }}>
              <div class="form-group">
                <label for="desc">Description</label>
                <input type="text"  placeholder="Enter Description" value={field.description} onChange={(e) => handleChange(index, 'description', e.target.value)}/>
              </div>
              <div class="form-group">
                <label for="upload">Upload Document (PDF only)</label>
                <div class="form-inline">
                  <input type="file"  accept=".pdf" onChange={(e) => handleFileChange(index, e.target.files[0])} ref={(el) => (fileInputRefs.current[index] = el)}/>
                  {field.document && <button class="btn" onClick={() => {
                    const fileURL = URL.createObjectURL(field.document);
                    window.open(fileURL, '_blank');
                  }}>
                    Preview
                  </button>}
                </div>
                {field.error && (
                  <p style={{ color: 'red', fontSize: '14px', margin: '5px 0 0' }}>{field.error}</p>
                )}
              </div>
            </div>
          ))}
          {fields.length < MAX_FIELDS && (
            <button type="button" onClick={addMoreFields} className="btn" disabled={!canAddMore()}     style={{
              backgroundColor: !canAddMore() ? '#ccc' : '#7B3FE4',
              color: 'white',
              padding: '10px 20px',
              border: 'none',
              borderRadius: '4px',
              cursor: !canAddMore() ? 'not-allowed' : 'pointer',
              marginTop: '10px',
            }} >
              Add more
            </button>
          )}
        </div>

          <div className="declaration-section" style={{ margin: "0rem 0", display: "flex", alignItems: "flex-start" }}>
            <input
              type="checkbox"
              id="declaration"
              name="declaration"
              checked={isDeclared}
              onChange={(e) => setIsDeclared(e.target.checked)}
              style={{ marginTop: "4px", marginRight: "8px" }}
            />
            <label htmlFor="declaration" style={{ fontSize: "0.9rem", color: "#555" }}>
              I hereby declare that all the information provided in the application is true and correct in every respect
              and if any information is found to be incorrect the application shall be liable to be rejected. <span style={{ color: "red" }}>*</span>
            </label>
          </div>

          {formError && <p style={{ color: 'red', marginTop: '10px' }}>{formError}</p>}

          <div className="form-submit">
            <button type="submit" disabled={submitLoading}>
              <span style={{ display: 'inline-flex', alignItems: 'center' }}>
              Resubmit Form
              {submitLoading && <span className="spinner"></span>}
            </span>
            </button>
          </div>
      </form>
      )}

      {applicationStatus==="rejected" && (
        <div class="section">
          <div className="remark-box rejected-remark-box">
            <span className="remark-label">Status:</span>
            <span className="remark-status rejected-text">Rejected</span>
            <br/>
            <span className="remark-label">Remark:</span>
            <span className="remark-message">{lastRemark.message}</span>
          </div>
        </div>
      )}

        {remarkOpen &&
          <RemarkModal 
            icon ={danger_icon}
            onClose={() => {setRemarkOpen(false); scrollToSection("resubmission-form");}}
            message={lastRemark.message}
          />
        }

        {modalOpen && (
        <Modal icon={green_check} message="Your grant schemes and scholarship form has been successfully re-submitted." onSubmit={() => {setModalOpen(false); navigate(`/grant-scheme`);}} buttonText="Continue to Dashboard" appId={applicationId}/>
        )}

      </div>
    </div>
  );
};

export default SubmittedSchemeForm;
